import styled from '@emotion/styled';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { withConfig } from 'src/withConfig';

export const SilkRaceSummaryCastHrWrapper = withConfig(theme => styled('div', { label: 'SilkRaceSummaryCastHrWrapper' })`
    align-items: center;
    border-right: 1px solid ${theme.star.raceSummary.borderColor};
    display: flex;
    flex: 0 0 40px;
    justify-content: center;
    img[src*='empty-hr-silk'] {
        width: 24px;
    }
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 65px;
    }
`);

export const SilkRaceSummaryCast = styled(LazyImageSilk, { label: 'SilkRaceSummaryCast' })`
    width: 29px;
`;

export const RunnerCell = withConfig(theme => styled('div', { label: 'RunnerCell' })`
    border-right: 1px solid ${theme.star.raceSummary.borderColor};
    font-size: ${theme.star.fontSize.xSmall};
    flex: 1 1 auto;
    padding: 14px 12px;
`);
